import room1 from "./images/details-1.jpeg";
import room2 from "./images/details-2.jpeg";
import room3 from "./images/details-3.jpeg";
import room4 from "./images/details-4.jpeg";
import img1 from "./images/room-1.jpeg";
import img2 from "./images/room-2.jpeg";
import img3 from "./images/room-3.jpeg";
import img4 from "./images/room-4.jpeg";
import img5 from "./images/room-5.jpeg";
import img6 from "./images/room-6.jpeg";
import img7 from "./images/room-7.jpeg";
import img8 from "./images/room-8.jpeg";
import img9 from "./images/room-9.jpeg";
import img10 from "./images/room-10.jpeg";
import img11 from "./images/room-11.jpeg";
import img12 from "./images/room-12.jpeg";
import video1 from "./Videos/video1.mp4";
import video2 from "./Videos/video2.mp4";
import video3 from "./Videos/video3.mp4";
import video4 from "./Videos/video4.mp4";
import video5 from "./Videos/video5.mp4";
import video6 from "./Videos/video6.mp4";
import video7 from "./Videos/video7.mp4";
import video8 from "./Videos/video8.mp4";
import video9 from "./Videos/video9.mp4";
import video10 from "./Videos/video10.mp4";
import video11 from "./Videos/video11.mp4";
import video12 from "./Videos/video12.mp4";
import video13 from "./Videos/video13.mp4";
import video14 from "./Videos/video14.mp4";
import video15 from "./Videos/video15.mp4";


const items = [
  {
    item_id: "1",
    saved: false,
    location: "Lavington",
    name: "Lavington single economy",
    type: "single",
    video:video9,
    price: 15000,
    size: 2500,
    capacity: 1,
    pets: false,
    featured: false,
    description:
      "This 1-bedroom apartment in Lavington has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img11, room3, room4, img3],
  },
  {
    item_id: "2",
    saved: false,
    location: "Kileleshwa",
    name: "Kileleshwa single economy",
    type: "single",
    video:video4,
    price: 15000,
    size: 2500,
    capacity: 1,
    pets: false,
    featured: false,
    description:
      "This 1-bedroom apartment in Kileleshwa has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img1, img2, room3, room4],
  },
  {
    item_id: "3",
    saved: false,
    location: "Kilimani",
    name: "Kilimani single economy",
    type: "single",
    price: 15000,
    size: 2500,
    video:video2,
    capacity: 1,
    pets: false,
    featured: false,
    description:
      "This 1-bedroom apartment in Kilimani has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img1, room2, room3, room4],
  },
  {
    item_id: "4",
    video:video3,
    saved: false,
    location: "Lavington",
    name: "Lavington single deluxe",
    type: "single",
    price: 20000,
    size: 3500,
    capacity: 1,
    pets: false,
    featured: false,
    description:
      "This 1-bedroom apartment in Lavington has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img1, img4, img5, room4],
  },
  {
    item_id: "5",
    saved: false,
    location: "Kileleshwa",
    name: "Kileleshwa single deluxe",
    type: "single",
    price: 20000,
    video:video5,
    size: 3500,
    capacity: 1,
    pets: false,
    featured: false,
    description:
      "This 1-bedroom apartment in Kileleshwa has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img1, img4, img5, room4],
  },
  {
    item_id: "6",
    saved: false,
    location: "Kilimani",
    name: "Kilimani single deluxe",
    type: "single",
    price: 20000,
    video:video6,
    size: 3500,
    capacity: 1,
    pets: false,
    featured: true,
    description:
      "This 1-bedroom apartment in Kilimani has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img5, img6, img5, room4],
  },
  {
    item_id: "7",
    saved: false,
    location: "Lavington",
    name: "Lavington double economy",
    video:video7,
    type: "double",
    price: 25000,
    size: 4000,
    capacity: 2,
    pets: false,
    featured: false,
    description:
      "This 2-bedroom apartment in Lavington has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img1, img4, img5, room4],
  },
  {
    item_id: "8",
    saved: false,
    location: "Kileleshwa",
    name: "Kileleshwa double economy",
    type: "double",
    price: 25000,
    size: 4000,
    video:video8,
    capacity: 2,
    pets: false,
    featured: false,
    description:
      "This 2-bedroom apartment in Kileleshwa has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img1, img6, img5, room4],
  },
  {
    item_id: "9",
    saved: false,
    video:video9,
    location: "Kilimani",
    name: "Kilimani double economy",
    type: "double",
    price: 25000,
    size: 4000,
    capacity: 2,
    pets: false,
    featured: false,
    description:
      "This 2-bedroom apartment in Kilimani has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img1, img7, img5, room4],
  },
  {
    item_id: "10",
    saved: false,
    video:video10,
    location: "Lavington",
    name: "Lavington double deluxe",
    type: "double",
    price: 30000,
    size: 4500,
    capacity: 2,
    pets: false,
    featured: false,
    description:
      "This 2-bedroom apartment in Lavington has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img8, img6, img5, room4],
  },
  {
    item_id: "11",
    saved: false,
    location: "Kileleshwa",
    name: "Kileleshwa double deluxe",
    type: "double",
    price: 30000,
    video:video11,
    size: 4500,
    capacity: 2,
    pets: false,
    featured: false,
    description:
      "This 2-bedroom apartment in Kileleshwa has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img8, img6, img5, room4],
  },
  {
    item_id: "12",
    saved: false,
    video:video12,
    location: "Kilimani",
    name: "Kilimani double deluxe",
    type: "double",
    price: 30000,
    size: 4500,
    capacity: 2,
    pets: false,
    featured: true,
    description:
      "This 2-bedroom apartment in Kilimani has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img9, img6, img1, room2],
  },
  {
    item_id: "13",
    saved: false,
    location: "Lavington",
    name: "Lavington family economy",
    type: "family",
    price: 35000,
    size: 5000,
    video:video13,
    capacity: 3,
    pets: false,
    featured: false,
    description:
      "This 3-bedroom apartment in Lavington has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img8, img6, room1, room4],
  },
  {
    item_id: "14",
    saved: false,
    video:video14,
    location: "Kileleshwa",
    name: "Kileleshwa family economy",
    type: "family",
    price: 35000,
    size: 5000,
    capacity: 3,
    pets: false,
    featured: false,
    description:
      "This 3-bedroom apartment in Kileleshwa has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img8, img9, room1, room4],
  },
  {
    item_id: "15",
    saved: false,
    location: "Kilimani",
    name: "Kilimani family economy",
    type: "family",
    price: 35000,
    video:video15,
    size: 5000,
    capacity: 3,
    pets: false,
    featured: false,
    description:
      "This 3-bedroom apartment in Kilimani has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img8, img7, room1, room4],
  },
  {
    item_id: "16",
    saved: false,
    video:video1,
    location: "Lavington",
    name: "Lavington family deluxe",
    type: "family",
    price: 40000,
    size: 5500,
    capacity: 3,
    pets: false,
    featured: true,
    description:
      "This 3-bedroom apartment in Lavington has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img4, img9, room1, room4],
  },
  {
    item_id: "17",
    saved: false,
    location: "Kileleshwa",
    name: "Kileleshwa family deluxe",
    type: "family",
    price: 40000,
    size: 5500,
    capacity: 3,
    pets: false,
    video:video2,
    featured: false,
    description:
      "This 3-bedroom apartment in Kileleshwa has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img8, img8, room3, room4],
  },
  {
    item_id: "18",
    saved: false,
    location: "Kilimani",
    name: "Kilimani family deluxe",
    type: "family",
    price: 40000,
    size: 5500,
    video:video13,
    capacity: 3,
    pets: false,
    featured: false,
    description:
      "This 3-bedroom apartment in Kilimani has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img8, img10, img5, room4],
  },
  {
    item_id: "19",
    saved: false,
    video:video3,
    location: "Lavington",
    name: "Lavington executive ",
    type: "executive",
    price: 45000,
    size: 6000,
    capacity: 4,
    pets: false,
    featured: false,
    description:
      "This 4-bedroom apartment in Lavington has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img8, img12, img5, room4],
  },
  {
    item_id: "20",
    saved: false,
   video:video2,
    location: "Kileleshwa",
    name: "Kileleshwa executive ",
    type: "executive",
    price: 45000,
    size: 6000,
    capacity: 4,
    pets: false,
    featured: false,
    description:
      "This 4-bedroom apartment in Kileleshwa has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img8, room2, img5, room4],
  },
  {
    item_id: "21",
    saved: false,
    location: "Kilimani",
    name: "Kilimani executive ",
    type: "executive",
    price: 45000,
    size: 6000,
    video:video5,
    capacity: 4,
    pets: false,
    featured: false,
    description:
      "This 4-bedroom apartment in Kilimani has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img8, img2, img5, room4],
  },
  {
    item_id: "22",
    saved: false,
    video:video8,
    location: "Lavington",
    name: "Lavington Premium",
    type: "premium",
    price: 50000,
    size: 6000,
    capacity: 5,
    pets: false,
    featured: false,
    description:
      "This 5-bedroom apartment in Lavington has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img8, img2, img5, room4],
  },
  {
    item_id: "23",
    saved: false,
    location: "Kileleshwa",
    video:video9,
    name: "Kileleshwa  Premium",
    type: "premium",
    price: 50000,
    size: 6000,
    capacity: 5,
    pets: false,
    featured: true,
    description:
      "This 5-bedroom apartment in Kileleshwa has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img8, img2, img5, room4],
  },
  {
    item_id: "24",
    saved: false,
    location: "Kilimani",
    name: "Kilimani Premium",
    type: "premium",
    price: 50000,
    size: 6000,
    video:video12,
    capacity: 5,
    pets: false,
    featured: false,
    description:
      "This 5-bedroom apartment in Kilimani has a separate bathroom and a separate bedroom with the  kitchen  separate from the living room, ",
    extras: [
      "Plush pillows and breathable bed linens",
      "Soft, oversized bath towels",
      "Full-sized, pH-balanced toiletries",
      "Complimentary refreshments",
      "Adequate safety/security",
      "Very Fast Internet Connectivity",
      "Comfortable beds",
    ],
    images: [img8, img2, img5, room4],
  },
  
];
export default items